import { NgModule } from '@angular/core';
import { Routes, RouterModule } from '@angular/router';
import { PageNotFoundComponent } from './pages/page-not-found/page-not-found.component';
import { PageHomeOneComponent } from './pages/page-home-one/page-home-one.component';
import { PageHomeTwoComponent } from './pages/page-home-two/page-home-two.component';
import { RootComponent } from './components/root/root.component';
import { CommonModule } from '@angular/common';
import { PageBonnyShopComponent } from './pages/page-bonnyshop/page-bonnyshop.component';
import { PageBakeryShopComponent } from './pages/page-bakeryshop/page-bakeryshop.component';
import { PageFreshComponent } from './pages/page-fresh/page-fresh.component';



const routes: Routes = [
    {
        path: '',
        component: RootComponent,
        data: {
            headerLayout: 'compact'
        },
        children: [
            {
                path: '',
                pathMatch: 'full',
                redirectTo: 'home'
            },
            {
                path: 'home',
                component: PageFreshComponent,
                data: { animation: 'bonnyShopPage'}
            },
            {
                path: 'account',
                loadChildren: () => import('./modules/account/account.module').then(m => m.AccountModule)
            },
            {
                path: 'shop',
                loadChildren: () => import('./modules/shop/shop.module').then(m => m.ShopModule)
            },
            {
                path: 'site',
                loadChildren: () => import('./modules/site/site.module').then(m => m.SiteModule)
            },
            {
                path: 'blog',
                loadChildren: () => import('./modules/blog/blog.module').then(m => m.BlogModule)
            },
            {
                path: '**',
                component: PageNotFoundComponent
            },
            {
                path: '404',
                component: PageNotFoundComponent
            }
        ],
    },
    {
        path: '**',
        redirectTo: 'compact'
    }
];

@NgModule({
    imports: [CommonModule, RouterModule.forRoot(routes, {
    scrollPositionRestoration: 'enabled',
    anchorScrolling: 'enabled',
    scrollOffset: [0, 64],
    relativeLinkResolution: 'legacy'
})],
    exports: [RouterModule]
})
export class AppRoutingModule { }
